import { getCurrentCulture } from "@utils/common/culture";

export const urlLanguageDetector = {
	name: "urlLanguageDetector",

	lookup() {
		return getCurrentCulture();
	},
};
